import { ProductTotalHistoryItemArray } from './../../models/ss-api/responses/product.total.history.item';
import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
// import { License } from 'app/models/domain/licensing/License';
import { LicenseManager } from '../../managers/License.manager';
import { SalesReportDetailsDialog } from '../../dialogs/sales.report.details/sales.report.details.dialog';

import { Message, SelectItem } from 'primeng/primeng';
import { ssApiService } from '../../services/ss-api.service';
import { SalesStatsRequest } from '../../models/ss-api/requests/sales.stats.request';
import { BillingCycleTypes } from '../../models/domain/invoice';
import { SalesItemArray, OrderSystems } from '../../models/ss-api/responses/sales.item';
import { SalesRepresentativeArray } from '../../models/domain/sales.representative';
import { GlobalService } from '../../services/global.service';
import { ProductItemBasicsArray } from '../../models/domain/product.item.basics';
import { ProductsTotalsRequest } from '../../models/ss-api/requests/products.totals.request';
import { ExportDataManager } from '../../managers/export.data.manager';
import { WindowService } from '../../../app/services/window-dialogs/window.service';
import { SortBot } from '../../../app/helpers/sort';
import { GetProductTotalHistoryRequest } from '../../../app/models/ss-api/requests/get.product.total.history.request';
import * as moment from 'moment';

@Component({
    selector: 'sales-report',
    templateUrl: './sales.report.component.html',
    styleUrls: ['./sales.report.component.scss']
})
export class SalesReportComponent implements OnInit {

    // VARIABLES
    IsBusy: boolean = false;

    private licenseManager: LicenseManager = new LicenseManager();

    StartDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    EndDate: Date = new Date();

    RecentSales: SalesItemArray = new SalesItemArray;
    Reactivations: SalesItemArray = new SalesItemArray;

    FilteredSales: SalesItemArray = new SalesItemArray;

    resultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    reactivationResultRows: number = 25;
    reactivationFirstResult: number = 0;
    reactivationLastResult: number = 24;

    SalesRepOptions: SelectItem[];
    ProductOptions: SelectItem[];
    CycleFilterOptions: SelectItem[];
    OrderSystemOptions: SelectItem[];
    StatusOptions: SelectItem[];

    SoftwareVersionFilter: string = '';
    ProductFilter: string = '';
    CycleFilter: string = '';
    OrderSystemFilter: number = -1;
    StatusFilter: number = -1;

    ReactivationFilter: string;

    // SALES DOONUUUUUT!
    SalesDonutData: any;
    SalesDonutOptions: any;

    donutVip3D: number = 0;
    donutPoolStudio: number = 0;
    donutVizTerra: number = 0;

    donutTotalSales: number = 0;

    donutStartDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    donutEndDate: Date = new Date();

    constructor(private dialogService: DialogService, private api: ssApiService, private gb: GlobalService, private windowService: WindowService) { }

    ngOnInit() {
        this.gb.SetPageTitle('Sales Report');
        this.GetChartData();
        this.setUpSalesDonut();

        // this.GetProductTotals();
        this.GetSalesReports();

        // this.FilteredSales = this.RecentSales;
        this.FilterSalesData();

        this.setUpFilterDropdowns();
    }

    GetProductTotals() {

        this.IsBusy = true;

        let request = new ProductsTotalsRequest();
        request.ProductIDs = new Array<number>();

        // TODO: dynamically push real product id's
        request.ProductIDs.push(5); // vip 3d
        request.ProductIDs.push(21); // vendor
        request.ProductIDs.push(8); // pool studio
        request.ProductIDs.push(9); // VizTerra
        request.ProductIDs.push(11); // GIS 1
        request.ProductIDs.push(12); // GIS 5
        request.ProductIDs.push(13); // GIS 10
        request.ProductIDs.push(14); // GIS 20
        request.ProductIDs.push(25); // GIS before migration package


        let subscription = this.api.StatisticsProductsTotals(request).subscribe(response => {
            subscription.unsubscribe();

            this.IsBusy = false;

            if (!response.Result) {
                return;
            }

            // console.log("data totals", response.Data);

        },
            error => {
                this.IsBusy = false;
            });

    }

    exportSalesReport() {
        let exporter = new ExportDataManager();
        exporter.ExportSalesStatistics(this.FilteredSales);
    }

    exportReactivations() {
        let exporter = new ExportDataManager();
        exporter.ExportSalesStatistics(this.Reactivations);
    }

    GetSalesReports() {

        this.IsBusy = true;

        let request = new SalesStatsRequest();
        request.DateStart = this.StartDate;
        request.DateStop = this.EndDate;
        request.IncludeFree = false;

        // request.ProductID = 1;
        // request.SalesRepID = 1;
        request.BillingCycle = BillingCycleTypes.NotDefined;

        console.log( request );
        //if( 0 == 0 ) return; 

        let subscription = this.api.StatisticsSales(request).subscribe(response => {
            subscription.unsubscribe();

            this.IsBusy = false;

            if (!response.Result) {
                return;
            }

            this.RecentSales = response.Data.SalesItems;
            this.Reactivations = response.Data.ReactivationItems;
            this.FilterSalesData();
            this.sortByDate();
            this.sortReactivationsByDate();

        },
            error => {
                this.IsBusy = false;
            });

    }

    setUpFilterDropdowns() {

        this.InitProducts();
        this.InitSalesReps();

        this.CycleFilterOptions = [
            { label: 'All', value: '' },
            { label: 'Monthly', value: 'Monthly' },
            { label: 'Annually', value: 'Annually' },
        ];

        this.OrderSystemOptions = [
            { label: 'All', value: -1 },
            { label: 'Member Panel', value: OrderSystems.MemberPanel },
            { label: 'Order Form', value: OrderSystems.OrderForm },
            { label: 'SSDB', value: OrderSystems.TeamPanel },
        ];

        this.StatusOptions = [
            { label: 'All', value: -1 },
            { label: 'Cancelled', value: 0 },
            { label: 'Active', value: 1 }
        ];
    }
    private async InitSalesReps() {

        let reps: SalesRepresentativeArray;

        await this.gb.GetSalesRepresentatives()
            .then(response => {
                reps = response;
            })
            .catch(error => {
                reps = new SalesRepresentativeArray();
            });

        this.SalesRepOptions = [];

        this.SalesRepOptions.push({ label: 'All', value: '' });

        reps.forEach(item => {
            this.SalesRepOptions.push({ label: item.FirstName + ' ' + item.LastName, value: item.FirstName + ' ' + item.LastName });
        });
    }

    private async InitProducts() {

        let products: ProductItemBasicsArray;

        await this.gb.GetStructureStudiosProductsBasics()
            .then(response => {
                products = response;
            })
            .catch(error => {
                products = new ProductItemBasicsArray();
            });

        this.ProductOptions = [];

        this.ProductOptions.push({ label: 'All', value: '' });

        if (products != null) {
            products.forEach(item => {
                if (item.ID == 1 || item.ID == 2 || item.ID == 3)
                    this.ProductOptions.push({ label: item.Name, value: item.Name });
            });
        }
    }

    top200Dialog(type: string) {

        let newTitle = 'Top Plants &amp; Trees';

        switch (type) {
            case 'assets':
                newTitle = 'Top Assets and Objects'; break;
        }

		/*
		let disposable = this.dialogService.addDialog(Top200DialogComponent, {
            title: newTitle,
            message: 'Confirm message'
		});
		*/
    }


    FilterSalesData() {

        this.FilteredSales = new SalesItemArray;

        this.donutVip3D = 0;
        this.donutPoolStudio = 0;
        this.donutVizTerra = 0;
        this.donutTotalSales = 0;

        this.RecentSales.forEach(item => {
            let SoftwareVersionString: string = item.SoftwareVersion;
            let MembershipString: string = item.ProductName;
            let CycleString: string = item.BillingCycle;
            let OrderSystem = item.OrderSystem;
            let StatusSystem = item.Status;

            if (this.SoftwareVersionFilter != '' && SoftwareVersionString != this.SoftwareVersionFilter)
                return;
            if (this.ProductFilter != '' && MembershipString != this.ProductFilter)
                return;
            if (this.CycleFilter != '' && CycleString != this.CycleFilter)
                return;
            if (this.OrderSystemFilter != -1 && OrderSystem != this.OrderSystemFilter)
                return;
            if (this.StatusFilter != -1)
                if (this.StatusFilter == 0 && (StatusSystem == 0 || StatusSystem == 1))
                    return;
            if (this.StatusFilter == 1 && (StatusSystem == 2 || StatusSystem == 3 || StatusSystem == 99))
                return;
            if (item.Amount <= 0) {
                return;
            }

            if (item.ProductName.includes('VIP3D'))
                this.donutVip3D += 1;

            if (item.ProductName == 'Pool Studio')
                this.donutPoolStudio += 1;

            if (item.ProductName == 'VizTerra')
                this.donutVizTerra += 1;

            this.FilteredSales.push(item);
        });

        this.donutTotalSales = this.donutPoolStudio + this.donutVip3D + this.donutVizTerra;

        this.setUpSalesDonut();

    }

    FilteredSalesCount(): number {
        let count = 0;

        this.FilteredSales.forEach(function (item) {
            let SoftwareVersionString: string = item.SoftwareVersion;
            let MembershipString: string = item.ProductName;
            let CycleString: string = item.BillingCycle;

            if (this.SoftwareVersionFilter != '' && SoftwareVersionString != this.SoftwareVersionFilter)
                return;
            if (this.ProductFilter != '' && MembershipString != this.ProductFilter)
                return;
            if (this.CycleFilter != '' && CycleString != this.CycleFilter)
                return;
            if (item.Amount <= 0) {
                return;
            } else {
                count++;
            }
        }, this);

        return count;
    }

    FilteredReactivationsCount(): number {
        let count = 0;

        this.Reactivations.forEach(function (item) {
            let SoftwareVersionString: string = item.SoftwareVersion;
            let MembershipString: string = item.ProductName;
            let CycleString: string = item.BillingCycle;

            if (this.SoftwareVersionFilter != '' && SoftwareVersionString != this.SoftwareVersionFilter)
                return;
            if (this.ProductFilter != '' && MembershipString != this.ProductFilter)
                return;
            if (this.CycleFilter != '' && CycleString != this.CycleFilter)
                return;
            if (item.Amount <= 0) {
                return;
            } else {
                count++;
            }
        }, this);

        return count;
    }



    setUpSalesDonut() {
        this.SalesDonutData = {
            labels: ['Vip3D', 'Pool Studio', 'VizTerra'],
            datasets: [
                {
                    data: [this.donutVip3D, this.donutPoolStudio, this.donutVizTerra],
                    backgroundColor: [
                        '#0054AE',
                        '#0088FF',
                        '#64A000'
                    ],
                    hoverBackgroundColor: [
                        '#1164BE',
                        '#1199FF',
                        '#73AF00'
                    ]
                }

            ]
        };

        this.SalesDonutOptions = {
            legend: {
                position: 'bottom'
            }
        };
    }


    showDetailsDialog() {
        let newTitle = 'Top Plants &amp; Trees';

        let disposable = this.dialogService.addDialog(SalesReportDetailsDialog, {
            // title: newTitle,
            // message: 'Confirm message'
			licenseManager : this.licenseManager,
			salesData: this.RecentSales
        });

    }


    onLicenseClick(license: string) {
        // show dialog
        // this.licenseManager.Load(license);
        this.IsBusy = true;
        let manager = new LicenseManager();
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(license, true);

        manager.OnChangesSaveResponse.subscribe(response => {
            this.GetChartData();
            this.setUpSalesDonut();
            this.GetSalesReports();
            this.FilterSalesData();
            this.setUpFilterDropdowns();
        });
        // var windowSettings = new WindowSettings();
        // windowSettings.Height = 900;
        // windowSettings.Width = 1240;

        // this.windowService.OpenWindow<string>(WindowTypes.License, license, windowSettings);

    }



    // /////////////////////////////////////////////////////////
    // CHART STUFFS  --  http://www.chartjs.org/docs/latest/
    // /////////////////////////////////////////////////////////

    chartResponse: ProductTotalHistoryItemArray = new ProductTotalHistoryItemArray();
    chartData: any = '';
    chartOptions: any;
    msgs: Message[];

    ChartMonthView: boolean = true;

    ChangeChartView(val: boolean) {
        this.ChartMonthView = val;
        this.GetChartData();
    }

    GetChartData() {
        let request: GetProductTotalHistoryRequest = {
            StartDate: moment().subtract(13, 'months').toDate(),
            EndDate: new Date(),
            FirstOfMonthOnly: this.ChartMonthView
        };

        let disposable = this.api.GetProductTotalHistory(request).subscribe(response => {
            this.chartResponse = response.Data;
            this.chartConfig();
            disposable.unsubscribe();
        });
    }

    chartConfig() {
        this.chartData = {
            labels: [],
            datasets: [
                {
                    label: 'VizTerra',
                    data: [],
                    fill: true,
                    backgroundColor: 'rgba(100,160,0,1)',
                    borderColor: 'rgba(255,255,255,1)',
                    borderWidth: 2
                },
                {
                    label: 'Pool Studio',
                    data: [],
                    fill: true,
                    backgroundColor: 'rgba(0,136,255,1)',
                    borderColor: 'rgba(255,255,255,1)',
                    borderWidth: 2
                },
                {
                    label: 'VIP3D',
                    data: [],
                    fill: true,
                    backgroundColor: 'rgba(0,84,174, 1)',
                    borderColor: 'rgba(255,255,255,1)',
                    borderWidth: 2
                }
            ]
        };

        let VIPItems = this.chartResponse.filter(vip => {
            return vip.Product_ID == 3;
        }).sort((left, right) => {
            if (moment(left.DateTimeCreated).isBefore(moment(right.DateTimeCreated))) {
                return -1;
            } else {
                return 1;
            }
        });
        let PoolStudioItems = this.chartResponse.filter(ps => {
            return ps.Product_ID == 2;
        }).sort((left, right) => {
            if (moment(left.DateTimeCreated).isBefore(moment(right.DateTimeCreated))) {
                return -1;
            } else {
                return 1;
            }
        });
        let VizTerraItems = this.chartResponse.filter(viz => {
            return viz.Product_ID == 1;
        }).sort((left, right) => {
            if (moment(left.DateTimeCreated).isBefore(moment(right.DateTimeCreated))) {
                return -1;
            } else {
                return 1;
            }
        });

        let TotalItems = this.chartResponse.filter(total => {
            return total.Product_ID == null && total.DisplayName == 'Total Members';
        }).sort((left, right) => {
            if (moment(left.DateTimeCreated).isBefore(moment(right.DateTimeCreated))) {
                return -1;
            } else {
                return 1;
            }
        });

        this.chartData.datasets[0].data = VizTerraItems.map(viz => {
            return viz.PaidTotal;
        });

        this.chartData.datasets[1].data = PoolStudioItems.map((ps, i) => {
            return ps.PaidTotal;
        });

        this.chartData.datasets[2].data = VIPItems.map((vip, i) => {
            return vip.PaidTotal;
        });

        VIPItems.forEach(function (item, i) {
            if (this.ChartMonthView) {
                this.chartData.labels.push(moment(item.DateTimeCreated).format('MMM YYYY'));
            } else {
                this.chartData.labels.push(moment(item.DateTimeCreated).format('MM/DD'));
            }
        }, this);

        this.chartOptions = {
            elements: {
                line: {
                    tension: 0
                },
                point: {
                    radius: '1',
                    hitRadius: '2',
                    borderColor: 'rgba(0,0,0,0)',
                    backgroundColor: 'rgba(0,0,0,0)'
                }
            },
            scales: {

                yAxes: [{
                    stacked: true,
                    ticks: {
                        beginAtZero: true,
                    },
                    gridLines: {
                        zeroLineColor: 'rgba(0,0,0,0)',
                        display: false
                    },
                    display: false
                }],
                xAxes: [{
                    gridLines: {
                        zeroLineColor: 'rgba(0,0,0,0)',
                        display: false
                    }
                }]
            },
            legend: {
                position: 'bottom'
            },
            tooltips: {
                callbacks: {
                    label: function (tooltipItems, data) {
                        let count;
                        switch (tooltipItems.datasetIndex) {
                            case 2:
                                let VIPItem = VIPItems[tooltipItems.index];
                                let TotalItem = TotalItems[tooltipItems.index];
                                if (VIPItem) count = VIPItem.PaidTotal + '  Total: ' + TotalItem.PaidTotal;
                                break;
                            case 1:
                                let PoolItem = PoolStudioItems[tooltipItems.index];
                                if (PoolItem) count = PoolItem.PaidTotal;
                                break;
                            case 0:
                                let VizItem = VizTerraItems[tooltipItems.index];
                                if (VizItem) count = VizItem.PaidTotal;
                                break;
                        }
                        let label = data.datasets[tooltipItems.datasetIndex].label + ': ' + count;
                        return label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    }
                }
            }
        };

    }

    NameForOrderSystem(type: OrderSystems) {
        switch (type) {
            case 0:
                return 'Unkown';
            case 1:
                return 'Order Form';
            case 2:
                return 'Member Panel';
            case 3:
                return 'SSDB';
        }
    }

    selectData(event) {
        this.msgs = [];
        this.msgs.push({ severity: 'info', summary: 'Data Selected', 'detail': this.chartData.datasets[event.element._datasetIndex].data[event.element._index] });
    }

    paginateSalesReport(e) {
        // console.log("paginateSearch :", e);
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

    paginateReactivationReport(e) {
        // console.log("paginateSearch :", e);
        this.reactivationFirstResult = e.page * e.rows;
        this.reactivationLastResult = this.reactivationFirstResult + e.rows;
    }

    // ////////////////////////////////////
    // SORT STUFF
    // ////////////////////////////////////

    sortByDate() { SortBot.SortAuto(this.FilteredSales, 'DateTimeCreated'); }
    sortByName() { SortBot.SortAuto(this.FilteredSales, 'MemberName'); }
    sortByCompany() { SortBot.SortAuto(this.FilteredSales, 'CompanyName'); }
    sortByCDKey() { SortBot.SortAuto(this.FilteredSales, 'LicenseKey'); }
    sortBySoftwareVersion() { SortBot.SortAuto(this.FilteredSales, 'SoftwareVersion'); }
    sortByOrderSystem() { SortBot.SortAuto(this.FilteredSales, 'OrderSystem'); }
    sortBySaleType() { SortBot.SortAuto(this.FilteredSales, 'LeadSource'); }
    sortByProduct() { SortBot.SortAuto(this.FilteredSales, 'ProductName'); }
    sortByCycle() { SortBot.SortAuto(this.FilteredSales, 'BillingCycle'); }
    sortByAmount() { SortBot.SortAuto(this.FilteredSales, 'Amount'); }
    sortByStatus() { SortBot.SortAuto(this.FilteredSales, 'Status'); }


    sortReactivationsByDate() { SortBot.SortAuto(this.Reactivations, 'DateTimeCreated'); }
    sortReactivationsByName() { SortBot.SortAuto(this.Reactivations, 'MemberName'); }
    sortReactivationsByCompany() { SortBot.SortAuto(this.Reactivations, 'CompanyName'); }
    sortReactivationsByCDKey() { SortBot.SortAuto(this.Reactivations, 'LicenseKey'); }
    sortReactivationsBySaleType() { SortBot.SortAuto(this.Reactivations, 'LeadSource'); }
    sortReactivationsByProduct() { SortBot.SortAuto(this.Reactivations, 'ProductName'); }
    sortReactivationsByCycle() { SortBot.SortAuto(this.Reactivations, 'BillingCycle'); }
    sortReactivationsByAmount() { SortBot.SortAuto(this.Reactivations, 'Amount'); }
    sortReactivationsByStatus() { SortBot.SortAuto(this.Reactivations, 'Status'); }
    sortReactivationsByOrderSystem() { SortBot.SortAuto(this.Reactivations, 'OrderSystem'); }


}
